module.exports = "<go-wrapper [title]=\"UI_TEXTS.GO_PLANT\"\n            [document]=\"document\"\n            [componentType]=\"componentType\">\n    <nv-action *ngIf=\"component\" [document]=\"action\"></nv-action>\n</go-wrapper>\n"


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/app/components/go/go-plant/go-plant.component.html
// module id = ../../../../../src/app/components/go/go-plant/go-plant.component.html
// module chunks = 0